import {useNavigate} from "react-router";
import {useEffect} from "react";
import {clearSavedListParams} from "../../../helpers/LocalStorageHelper";
import {USERS_ROUTE} from "../../../routes";

export function UsersClear() {
    const history = useNavigate()
    useEffect(() => {
        clearSavedListParams();
        history(USERS_ROUTE, {replace: true});
    }, []);
    return <div/>
}